/** @jsxImportSource solid-js */
import { createSignal, For } from "solid-js";

function createCodeItem(props: {
  value: string;
  onInput: (val: string) => void;
  moveBack: () => void;
}) {
  let ref!: HTMLInputElement;
  const actualInput = (
    <input
      class="w-full h-full flex flex-col items-center justify-center text-center px-2 outline-none rounded-xl border border-gray-200 text-lg bg-white focus:bg-gray-50 focus:ring-1 ring-blue-700"
      type="text"
      size={1}
      name=""
      id=""
      ref={ref}
      value={props.value}
      onInput={(e) => {
        props.onInput(e.currentTarget.value);
      }}
      onKeyDown={(e) => {
        if (e.key === "Backspace") {
          e.preventDefault();
          props.moveBack();
        }
      }}
    />
  );
  return {
    component: <div class="w-12 h-16">{actualInput}</div>,
    ref,
  };
}

export function createCodeInput({ length = 6 }) {
  const [digits, setDigits] = createSignal<string[]>(Array(length).fill(""));
  const inputs: HTMLInputElement[] = Array(length).fill(undefined);

  // TODO: make this accept numbers only
  function handleInput(n: number, val: string) {
    if (val.length > 1) {
      const pastedOtp = val.substring(0, length);
      setDigits(pastedOtp.split(""));
    } else {
      const newOtp = [...digits()];
      newOtp[n] = val;
      setDigits(newOtp);
    }
    if (n < inputs.length - 1) {
      inputs[n + 1].focus();
    }
  }

  return {
    component: (
      <div>
        <div class="flex flex-row items-center justify-between mx-auto w-full">
          <For each={digits()}>
            {(segment, idx) => {
              const e = createCodeItem({
                value: segment,
                onInput: (val: string) => handleInput(idx(), val),
                moveBack: () => {
                  const previous = idx() - 1;
                  const newOtp = [...digits()];
                  newOtp[previous] = "";
                  setDigits(newOtp);

                  inputs[previous].focus();
                },
              });
              inputs[idx()] = e.ref;
              return e.component;
            }}
          </For>
        </div>
        <strong class="text-status-error-fg p-2 hidden group-data-[validate=true]:block">
          Please enter a valid {length}-digit PIN.
        </strong>
      </div>
    ),
    value: () => digits().join(""),
  };
}
